import axios from 'axios'

async function getAllCountries () {
  return axios.get('/admin/countries')
}

export default {
  getAllCountries
}



// WEBPACK FOOTER //
// ./src/api/countries.js